import React, {useEffect, useState} from 'react';
import { Redirect } from 'react-router';
import Breadcrumbs from './Breadcrumbs';


const Covidlive = () => {
    const [data,setData] = useState([]);

    const getCovidData = async() =>{
        try{
            const res = await  fetch('https://api.covid19india.org/data.json');
            const actualData = await res.json();
           // console.log(actualData.statewise[0]);
            setData(actualData.statewise[0]);

        }
        catch(err){
            console.log(err);
        }
    }
    useEffect(() => {
        getCovidData();
       
    }, [])
    return (
        <>
                  <Breadcrumbs name="India Covid-19 Live Report" linename="covid"/>

                  <section id="services" className="services">
      <div className="container">

        <div className="section-title">
          <h2>Live </h2>
          <p>India Covid-19 Corona Virus Tracker</p>
        </div>

        <div className="row">
          <div className="col-md-4" >
            <div className="icon-box" style={{backgroundColor:"#004d4d",color:"white"}}>
                            <h4 style={{fontSize:"16px",color:"white"}}>Country</h4>
              <p style={{fontSize:"20px",color:"white"}}>India</p>
            </div>
          </div>
          <div className="col-md-4 mt-4 mt-md-0">
            <div className="icon-box" style={{backgroundColor:"#2eb82e",color:"white"}}>
           
              <h4 style={{fontSize:"16px",color:"white"}}>Total Recovered</h4>
              <p  style={{fontSize:"20px",color:"white"}}>{data.recovered}</p>

            </div>
          </div>
          <div className="col-md-4 mt-4 mt-md-0">
            <div className="icon-box" style={{backgroundColor:"#ff9999",color:"white"}}>
               <h4 style={{fontSize:"16px",color:"white"}}>Total Confirmed</h4>
              <p  style={{fontSize:"20px",color:"white"}}>{data.confirmed}</p>

            </div>
          </div>
          <div className="col-md-4 mt-4 mt-md-0">
            <div className="icon-box" style={{backgroundColor:"#ff0055",color:"white"}}>
                            <h4  style={{fontSize:"16px",color:"white"}}>Total Death</h4>
              <p  style={{fontSize:"20px",color:"white"}}>{data.deaths}</p>
            </div>
          </div>
          <div className="col-md-4 mt-4 mt-md-0">
            <div className="icon-box" style={{backgroundColor:"#006666",color:"white"}}>
                         <h4 style={{fontSize:"16px",color:"white"}}>Total Active</h4>
              <p style={{fontSize:"20px",color:"white"}}>{data.active}</p>
            </div>
          </div>
          <div className="col-md-4 mt-4 mt-md-0">
            <div className="icon-box" style={{backgroundColor:"#00e6e6",color:"white"}}>
              
              <h4 style={{fontSize:"16px",color:"white"}}>Last Updated</h4>
              <p style={{fontSize:"20px",color:"white"}}>{data.lastupdatedtime}</p>
            </div>
          </div>
        </div>

      </div>
    </section>
        </>
    )
}

export default Covidlive;
